// extracted by mini-css-extract-plugin
export default {"iconExternalLink":"iconExternalLink_3J9K"};